<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left></vdr-ab-left>
    <vdr-ab-right>
      <vdr-action-bar-items
        [locationId]="'notification-list'"
      ></vdr-action-bar-items>
      <a class="btn btn-primary" [routerLink]="['./', 'create']">
        <clr-icon shape="cloud"></clr-icon>
        {{ "push.new-push" | translate }}
      </a>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>

<vdr-data-table-2
  id="notifications-list"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="notifications-list"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  />

  <vdr-dt2-search
    [searchTermControl]="searchTermControl"
    searchTermPlaceholder="Filter by title"
  />

  <vdr-dt2-column
    id="id"
    [heading]="'common.id' | translate"
    [hiddenByDefault]="true"
  >
    <ng-template let-noti="item"> {{ noti.id }} </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    id="created-at"
    [heading]="'common.created-at' | translate"
    [hiddenByDefault]="true"
    [sort]="sorts.get('createdAt')"
  >
    <ng-template let-noti="item">
      {{ noti.createdAt | localeDate : 'short' }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    id="updated-at"
    [heading]="'common.updated-at' | translate"
    [hiddenByDefault]="true"
    [sort]="sorts.get('updatedAt')"
  >
    <ng-template let-noti="item">
      {{ noti.updatedAt | localeDate : 'short' }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column id="title" heading="Title" [sort]="sorts.get('title')">
    <ng-template let-noti="item">
      <a class="button-ghost" [routerLink]="['./', noti.id]"
        ><span>{{ noti.title }}</span>
        <clr-icon shape="arrow right"></clr-icon>
      </a>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="isScheduled"
    heading="Send Type"
    [hiddenByDefault]="false"
  >
    <ng-template let-noti="item">
      <vdr-chip *ngIf="noti.isScheduled">{{ "Scheduled" }}</vdr-chip>
      <vdr-chip *ngIf="!noti.isScheduled">{{ "Immediately" }}</vdr-chip>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    id="schedule"
    heading="Schedule Time"
    [sort]="sorts.get('scheduledTime')"
  >
    <ng-template let-noti="item"
      >{{ noti.scheduledTime | localeDate }}</ng-template
    >
  </vdr-dt2-column>
  <vdr-dt2-column
    id="isDeveloperNotification"
    heading="Type"
    [hiddenByDefault]="true"
  >
    <ng-template let-noti="item">
      <vdr-chip *ngIf="noti.isDevelopment" colorType="warning"
        >{{ "Test" }}</vdr-chip
      >
      <vdr-chip *ngIf="!noti.isDevelopment" colorType="success"
        >{{ "Production" }}</vdr-chip
      >
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column id="targets" [hiddenByDefault]="false" heading="Targets">
    <ng-template let-noti="item">
      <span *ngIf="noti.targets.length > 0; else showAll">
        {{ noti.targets.length }}
      </span>
      <ng-template #showAll> All </ng-template>
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
